import React from 'react'
import * as yup from 'yup'

export interface WizardStepProps {
  children: React.ReactElement
  name: string
  onSubmit?: Function
  validationSchema?: yup.ObjectSchema<any>
}

export const WizardStep: React.FunctionComponent<WizardStepProps> = ({
  children,
}) => children
